import React from 'react';
import withAuth from './with-auth';

const forAdminOnly = (Component) =>
  withAuth(({ isOwner, ...props }) => {
    return isOwner ? <Component {...props} /> : null;
  });

export default forAdminOnly;
